/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GraphResponse } from '../models/GraphResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class GraphDataService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get Node By Element Id
     * Get a single node by its element_id
     *
     * Args:
     * element_id: The element ID of the node to retrieve
     *
     * Returns:
     * GraphResponse with the node data
     * @param elementId
     * @returns GraphResponse Successful Response
     * @throws ApiError
     */
    public getNodeByElementIdApiV1GraphNodeElementIdGet(
        elementId: string,
    ): CancelablePromise<GraphResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/graph/node/{element_id}',
            path: {
                'element_id': elementId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Available Root Nodes
     * Get list of available root nodes for selection
     *
     * Public Access: Returns all nodes, but marks which are public vs require authentication.
     * Unauthenticated users will only see public nodes.
     *
     * Returns:
     * List of nodes with element_id, name, and access info
     * @returns any Successful Response
     * @throws ApiError
     */
    public getAvailableRootNodesApiV1GraphRootsGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/graph/roots',
        });
    }
    /**
     * Get Incoming Graph
     * Get all incoming nodes and relationships for a given node
     *
     * This endpoint returns the complete graph structure with all nodes that have
     * PART_OF relationships leading to the specified node.
     *
     * Public Access: Solar Photovoltaic (PV) System is publicly accessible.
     * Other value chains require authentication and permissions.
     *
     * Args:
     * element_id: The element ID of the target node
     *
     * Returns:
     * GraphResponse with all incoming nodes and relationships
     * @param elementId
     * @param maxIterations Maximum n_iteration levels to traverse upwards
     * @param minThreshold Minimum path weight to include a relationship
     * @returns GraphResponse Successful Response
     * @throws ApiError
     */
    public getIncomingGraphApiV1GraphIncomingElementIdGet(
        elementId: string,
        maxIterations: number = 4,
        minThreshold?: number,
    ): CancelablePromise<GraphResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/graph/incoming/{element_id}',
            path: {
                'element_id': elementId,
            },
            query: {
                'max_iterations': maxIterations,
                'min_threshold': minThreshold,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Incoming Uneven Graph
     * Get all incoming nodes and relationships for a given node with uneven traversal
     *
     * This endpoint returns the complete graph structure with all nodes that have
     * relationships leading to the specified node, using uneven traversal logic.
     *
     * Public Access: Solar Photovoltaic (PV) System is publicly accessible.
     * Other value chains require authentication and permissions.
     *
     * Args:
     * element_id: The element ID of the target node
     *
     * Returns:
     * GraphResponse with all incoming nodes and relationships
     * @param elementId
     * @param maxIterations Maximum n_iteration levels to traverse upwards
     * @param minThreshold Minimum path weight to include a relationship
     * @returns GraphResponse Successful Response
     * @throws ApiError
     */
    public getIncomingUnevenGraphApiV1GraphIncomingUnevenElementIdGet(
        elementId: string,
        maxIterations: number = 4,
        minThreshold?: number,
    ): CancelablePromise<GraphResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/graph/incoming-uneven/{element_id}',
            path: {
                'element_id': elementId,
            },
            query: {
                'max_iterations': maxIterations,
                'min_threshold': minThreshold,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Incoming Even Graph
     * Get all incoming nodes and relationships for a given node with even-iteration traversal
     *
     * This endpoint returns the graph where paths start from nodes of types Material | MaterialCollection | System
     * that have even n_iteration values.
     *
     * Public Access: Allowed only when the node's source_db is public (env or pseudo-user grants).
     * Otherwise requires authentication and UserDataPermissions(data_type='graph_source', data_identifier=source_db),
     * with admin bypass.
     * @param elementId
     * @param maxIterations Maximum n_iteration levels to traverse upwards
     * @param minThreshold Minimum path weight to include a relationship
     * @returns GraphResponse Successful Response
     * @throws ApiError
     */
    public getIncomingEvenGraphApiV1GraphIncomingEvenElementIdGet(
        elementId: string,
        maxIterations: number = 4,
        minThreshold?: number,
    ): CancelablePromise<GraphResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/graph/incoming-even/{element_id}',
            path: {
                'element_id': elementId,
            },
            query: {
                'max_iterations': maxIterations,
                'min_threshold': minThreshold,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Incoming Grouped By Hs
     * Return a graph grouped by TechnologyType iteration and HS code.
     *
     * Nodes of type TechnologyType are collapsed by key "{n_iteration}: {hs_code[0]}".
     * Flows are aggregated between those grouped nodes.
     * Other node types remain distinct.
     *
     * Public Access: Solar Photovoltaic (PV) System is publicly accessible.
     * Other value chains require authentication and permissions.
     * @param elementId
     * @param maxIterations Maximum n_iteration levels to traverse upwards
     * @param minThreshold Minimum path weight to include a relationship
     * @returns GraphResponse Successful Response
     * @throws ApiError
     */
    public getIncomingGroupedByHsApiV1GraphIncomingGroupedHsElementIdGet(
        elementId: string,
        maxIterations: number = 4,
        minThreshold?: number,
    ): CancelablePromise<GraphResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/graph/incoming-grouped-hs/{element_id}',
            path: {
                'element_id': elementId,
            },
            query: {
                'max_iterations': maxIterations,
                'min_threshold': minThreshold,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Incoming Grouped By Prodcom
     * Return a graph grouped by TechnologyType iteration and PRODCOM code for the selected PRODCOM version.
     *
     * Nodes of type TechnologyType are collapsed by key "{n_iteration}: {selected version PROD-COM code}".
     * Flows are aggregated between those grouped nodes.
     * Other node types remain distinct.
     *
     * Public Access: Solar Photovoltaic (PV) System is publicly accessible.
     * Other value chains require authentication and permissions.
     * @param elementId
     * @param maxIterations Maximum n_iteration levels to traverse upwards
     * @param minThreshold Minimum path weight to include a relationship
     * @param prodcomVersion PRODCOM version to use for grouped codes (e.g. 2024, 2025)
     * @returns GraphResponse Successful Response
     * @throws ApiError
     */
    public getIncomingGroupedByProdcomApiV1GraphIncomingGroupedProdcomElementIdGet(
        elementId: string,
        maxIterations: number = 4,
        minThreshold?: number,
        prodcomVersion: string = '2024',
    ): CancelablePromise<GraphResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/graph/incoming-grouped-prodcom/{element_id}',
            path: {
                'element_id': elementId,
            },
            query: {
                'max_iterations': maxIterations,
                'min_threshold': minThreshold,
                'prodcom_version': prodcomVersion,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bust Graph Cache
     * @param elementId
     * @returns any Successful Response
     * @throws ApiError
     */
    public bustGraphCacheApiV1GraphCacheBustPost(
        elementId?: (string | null),
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/graph/cache/bust',
            query: {
                'element_id': elementId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Refresh Public Caches
     * Admin-only: Refresh public access caches (element auto-discovery and pseudo-user public sources).
     * @param refreshUser Re-resolve public user id when set to 1
     * @returns any Successful Response
     * @throws ApiError
     */
    public refreshPublicCachesApiV1GraphPublicRefreshPost(
        refreshUser?: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/graph/public/refresh',
            query: {
                'refresh_user': refreshUser,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Graph Sources
     * Return a distinct list of ALL source_db values with counts.
     *
     * Security: Admin-only (sensitive enumeration). Requires role 'admin'/'superuser'
     * or active UserDataPermissions('admin','admin'). Cached in Redis for 1 hour; pass ?refresh=1 to bypass.
     * @param refresh Bypass cache when set to 1
     * @returns any Successful Response
     * @throws ApiError
     */
    public getGraphSourcesApiV1GraphSourcesGet(
        refresh?: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/graph/sources',
            query: {
                'refresh': refresh,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
